import React from 'react'
import { getUnixTime } from 'date-fns'
import Box from '@material-ui/core/Box'
import { formatDate, formatTime } from '../../../utils/default/TableHelper'

interface PropTypes {
  time: Date
  lineBreak?: boolean
}

const DateTime: React.FC<PropTypes> = (props) => {
  const { time, lineBreak = true } = props
  const unixTime = getUnixTime(time)
  if (unixTime === -1) return (<Box>--</Box>)
  return (
    <Box>
      {formatDate(time)}
      {lineBreak ? <br /> : ' '}
      {formatTime(time)}
    </Box>
  )
}

export default React.memo(DateTime)
